import { AsYouType } from "libphonenumber-js"

export function maskPhone(value: string) {
    const skip = /\(\d{3}$/.test(value)
    if (skip) {
        return value
    }
    const digits = value.replace(/\D/g,"")
    return new AsYouType("US").input(digits)
}